<template>
    <div class="check_choose">
        <div class="choose_title"
             v-if="type!=7&&(ask.subject.content || length>1)">
            <span v-if="length>1 && sid==92">({{index+1}})</span>
            <span class="stem"
                  v-if="ask.subject.content"
                  v-html="ask.subject.content"></span>
            <p v-for="askImg in ask.subject.images"
               v-if="ask.subject.images.length"><img :src="askImg"></p>
        </div>
        <div class="showBtn"
             @click="showBtn"
             v-if="mytask!=1">{{showBtnCon}}<i :class="{'icon_bottom':!chooseShowBtn,'icon_top':chooseShowBtn}"></i></div>
        <template v-if='!!checked'>
            <div :class="[ask.stu_answer===item_sub.option?'choose_opation inspect_myColor clearfix':'choose_opation clearfix']"
                 v-for="(item_sub,index_sub) in ask.options"
                 v-if="chooseShowBtn">
                <i class="option"
                   v-html='item_sub.option'></i>
                <span style="background: transparent;"
                      v-html='item_sub.content'></span>
                <p class="choose_img_pic"
                   v-if="item_sub.image!=''">
                    <img :src="item_sub.image"
                         alt="">
                </p>
            </div>
        </template>
        <template v-else>
            <div :class="[ask.right_option.option===item_sub.option||ask.right_option===item_sub.option?'choose_opation active clearfix':'choose_opation clearfix']"
                 v-for="(item_sub,index_sub) in ask.options"
                 v-if="chooseShowBtn">
                <i class="option"
                   v-html='item_sub.option'></i>
                <span style="background: transparent;"
                      v-html='item_sub.content'></span>
                <p class="choose_img_pic"
                   v-if="item_sub.image!=''">
                    <img :src="item_sub.image"
                         alt="">
                </p>
            </div>
        </template>
    </div>
</template>

<script type="text/ecmascript-6">

export default {
    data () {
        return {
            showBtnCon: '展开选项',
            chooseShowBtn: false,
        }
    },
    components: {},
    props: ['ask', 'length', 'index', 'sid', 'isAudio', 'mystatus', 'checked', 'myColor', 'type'],
    //mystatus  1是查看单个学生作业情况 不显示展示
    //isAudio   不为空为听力题，默认展示选项
    computed: {
        is_audio () {//听力默认展开选项
            if (this.isAudio != '' && this.isAudio) {
                return true;
            } else {
                return false;
            }
        },
        mytask () {
            return this.mystatus ? 1 : 0;
        }
    },
    methods: {
        showBtn () {
            this.chooseShowBtn = !this.chooseShowBtn;
            if (this.chooseShowBtn) {
                this.showBtnCon = '收起选项';
            } else {
                this.showBtnCon = '展开选项';
            }
        },
    },
    created () {
        //console.log(this.checked)
        if (this.mytask == 1) {
            this.chooseShowBtn = true;
        } else {
            if (this.is_audio) {
                this.chooseShowBtn = true;
                this.showBtnCon = '收起选项';
            }
        }
    }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
@import "./src/assets/scss/common/_mixin";

.check_choose {
    .choose_title {
        line-height: 50px / $ppr;
        padding: 32px / $ppr 24px / $ppr;
        border-top: 1px / $ppr solid #dcdcdc;
        p {
            line-height: 50px / $ppr;
        }
    }
    // .stem{
    //   // padding: 32px/$ppr 24px/$ppr;
    //   // line-height: 50px/$ppr;
    //   border-top: 1px/$ppr solid #dcdcdc;
    // }
    .choose_opation {
        position: relative;
        padding: 32px / $ppr 24px / $ppr 32px / $ppr 96px / $ppr;
        border-top: 1px / $ppr solid #dcdcdc;
        &.active {
            color: #fff;
            .option {
                border: 1px / $ppr solid #66cc22;
                background: #66cc22;
            }
            span {
                color: #66cc22;
            }
        }
        &.inspect_myColor {
            color: #fff;
            .option {
                border: 1px / $ppr solid #5d89ef;
                background: #5d89ef;
            }
            span {
                color: #5d89ef;
            }
        }
        .option {
            display: block;
            position: absolute;
            top: 50%;
            left: 24px / $ppr;
            margin-top: -24px / $ppr;
            width: 48px / $ppr;
            height: 48px / $ppr;
            line-height: 48px / $ppr;
            text-align: center;
            border-radius: 48px / $ppr;
            border: 1px / $ppr solid #dcdcdc;
        }
    }
}
.showBtn {
    border-top: $line 1px / $ppr solid;
    line-height: 96px / $ppr;
    height: 96px / $ppr;
    color: #5e89ef;
    font-size: 30px / $ppr;
    padding-left: 40px / $ppr;
    position: relative;
    background: #fff;
    i {
        display: block;
        width: 25px / $ppr;
        height: 13px / $ppr;
        position: absolute;
        top: 42px / $ppr;
        left: 170px / $ppr;
    }
    .icon_bottom {
        background: url("./tea/img/icon_open.png") 0 0 no-repeat;
        background-size: 100% 100%;
    }
    .icon_top {
        background: url("./tea/img/icon_close.png") 0 0 no-repeat;
        background-size: 100% 100%;
    }
}
</style>
